import { LocalMediaStorage } from "@vidstack/react";

export class LocalMediaStorageWithoutTime extends LocalMediaStorage {
  async setTime(time: number, ended: boolean) {}
}
